export enum SupportedLambdaProposalKey {
  TransferProposal = "transfer_proposal",
  ConfigurationProposal = "configuration_proposal",
  UpdateGuardianProposal = "update_guardian_proposal",
  UpdateContractDelegateProposal = "update_contract_delegate_proposal",
  UpdateReceiversProposal = "update_receivers_proposal"
}
